
 
import { reactive, inject, ref, onMounted, nextTick, getCurrentInstance, computed} from 'vue';
import Search from '@/components/home/search.vue'
import Banner from '@/components/home/banner.vue'
import Advert from '@/components/home/advert.vue'
import IconDesign from '@/components/icon-design/icon-design.vue'
import FlashSale from '@/components/home/seckill.vue';
import ProductList from '@/components/home/product-list.vue';
import HotCategories from '@/components/home/popular-categories.vue'
import Tabbar from '@/components/tabbar/index.vue'
import { useRouter, useRoute} from 'vue-router'
import { Dialog } from 'vant';
import GoogleLogin from '@/views/googleLogin/index.vue'
 


export default {
   components: {
    Search,
    Banner,
    Advert,
    IconDesign,
    FlashSale,
    ProductList,
    HotCategories,
    Tabbar,
    GoogleLogin
},
  props:{},
  setup(props: object){
      // 是否在传音APP内
      const isByteApp = sessionStorage.getItem('source') === 'byteApp'

      const app_token = computed(() => {
        return common.getStorage('access_token')
      })

      const $http: any = inject('$http'),
            $store: any = inject('$store'),
            home_div: any = ref(),
            tabbar_index = ref(0);
      const internalInstance  = getCurrentInstance();
      const sa_track_fn = (event: any) => {
        internalInstance?.appContext.config.globalProperties.$sa.quick('trackHeatMap', event.currentTarget)
      }
      
      const route: any = useRoute(),
          router = useRouter();

      let home_datas: any = reactive([]),
          search_title: any = ref(null),
          is_show_pwa_msg: any = ref(true);
      
      let installPromptEvent: any = ref();
      window.addEventListener('beforeinstallprompt', (event) => {
        console.log(99999)
        event.preventDefault()  // Chrome <= 67 可以阻止显示
        installPromptEvent.value = event // 拿到事件的引用
      })
      /**
       * 数据解析
       */
      const datas_init_fn = (ret: any) => {
        if(ret!= null && ret.length > 0) {
          // GA埋点
           if (common.getStorage('start_time')) {
          var start_time = common.getStorage('start_time')
          var end_time = new Date().getTime() - start_time
          // @ts-ignore
          ga('send', 'timing', 'new wap index', 'load', end_time)
        }
          const datas = ret
          for (var i in datas) {
            let key = Object.getOwnPropertyNames(datas[i])[0]
            let value = datas[i][key]
            if(key === 'search') {
              search_title.value = value.title
            }
            let tmpData = Object.assign({}, {floor_name: key}, value)
            home_datas.push(tmpData)
          }
        }
      }

      /**
       * 获取首页数据
       */
      const get_home_datas = (async ()=>{      
        let store_datas = $store.getHomeDatas()
        if(store_datas && store_datas.length > 0) {
          // 调用函数
          datas_init_fn(store_datas)
          return false;
        }
        const ret = await $http.get_special_home({s: new Date().getTime()})
        $store.setHomeDatas(ret)
        datas_init_fn(ret)
        
      })
      // 首页数据初始化
      get_home_datas()

      const get_category_tree_fn = (async ()=>{      
        const ret = await $http.get_category_tree()
        if(ret!= null && ret.code == 200) {
          let cls_datas = JSON.stringify(ret.data)
          common.setStorage('cls_datas', cls_datas, 1)
        }
      })
      const pwa_init_fn = () => {
        nextTick(() => {
          Dialog.confirm({
            className: 'pda_message_div',
            confirmButtonText: 'Add',
            cancelButtonText: 'Cancel',
            title: 'Do you want to add a shortcut to your home screen for easy access？',
            message: 'Tips: Adding the shortcut won\'t consume any mobile data.',
          })
          .then(() => {
            setTimeout(() => {
              installPromptEvent.value.prompt()
            }, 100)
          })
          .catch(() => {
          });
          is_show_pwa_msg.value = false;
        });
      };
      onMounted(() =>{
        let home_div: any = document.querySelector('.home_div'),
            store_top: any = $store.getHomeScrollTop();

        if(store_top > 0) {
              home_div.scrollTop  = 300
              console.dir(home_div)
              setTimeout(() => {
                  home_div.scrollTop = store_top
              }, 1000);
        }
 
        
        home_div.addEventListener('scroll', () => {
          const scroll: any = home_div.scrollTop;
          if(scroll > 1000 && is_show_pwa_msg.value && installPromptEvent.value && installPromptEvent.value.prompt) {
            pwa_init_fn();
          }

          $store.setHomeScrollTop(scroll);
          const item_obj: any = document.querySelector('.sticky_div')
          const item_height: number = item_obj?.clientHeight
          if(item_obj == null) return false
          if(item_height != null && scroll >= item_height) {
            item_obj.classList.add('sticky_sld')
          }
          else {
            item_obj.classList.remove('sticky_sld')
          }
        }) 
        if(common.getStorage('cls_datas')) {
          return false;
        }
        get_category_tree_fn()
      })

      
      
      return {
         home_datas,
         search_title,
         tabbar_index,
         home_div,
         app_token,
         isByteApp
      }
    }
  
}
